import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import _ from "lodash";
import moment from "moment";
import humanizeDuration from "humanize-duration";
import { changeVehicle } from "./historyReport/historyReport";

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

export const dateFormat = "DD-MMM-YYYY HH:mm";

class SwiggyReport {
  constructor() {
    this.finalData = null;
    this.schema = this.createSchema();
  }

  downloadReport = (schema) => {
    if (window.tab == 0 || window.tab == undefined) {
      JSONToCSVConvertor(window.swiggyTableData, "Swiggy Report", false);
    } else {
      JSONToCSVConvertor(
        window.swiggyAggData,
        "Swiggy Aggregate Report",
        false
      );
    }
  };

  handleSuccess = (resp) => {
    this.finalData = null;
    let reportData = [];
    window.check = [];
    let swiggyTableData = [];
    let swiggyAggData = [];

    if (resp.length < 1) {
      window.setReportWindowTabBusy(this.schema, false);
    } else {
      // Process aggregate data
      for (let i = 0; i <= resp[0].aggregatedata.length - 1; i++) {
        let obj = resp[0].aggregatedata[i];
        obj.starttime = moment(obj.starttime).format("DD-MMM");
        obj.endtime = moment(obj.endtime).format("DD-MMM");
        obj.groupL1 = obj.groups[0] ? obj.groups[0] : "";
        obj.groupL2 = obj.groups[1] ? obj.groups[1] : "";
        obj.groupL3 = obj.groups[2] ? obj.groups[2] : "";
        obj.groupL4 = obj.groups[3] ? obj.groups[3] : "";
        obj.date =
          moment(obj.starttime).format("DD-MMM") +
          " - " +
          moment(obj.endtime).format("DD-MMM");
        obj.duration = shortEnglishHumanizer(obj.duration, {
          round: true,
          largest: 2,
        });
        obj.drivingtime = shortEnglishHumanizer(obj.drivingtime, {
          round: true,
          largest: 2,
        });
        obj.idlingtime = shortEnglishHumanizer(obj.idlingtime, {
          round: true,
          largest: 2,
        });
        obj.waitingtime = shortEnglishHumanizer(obj.waitingtime, {
          round: true,
          largest: 2,
        });
        obj.avgspeed =
          obj.avgspeed % 1 != 0
            ? parseFloat(obj.avgspeed).toFixed(2)
            : obj.avgspeed;
        obj.netearning =
          obj.netearning % 1 != 0
            ? parseFloat(obj.netearning).toFixed(0)
            : obj.netearning;
        obj.cost =
          obj.cost % 1 != 0 ? parseFloat(obj.cost).toFixed(0) : obj.cost;
        swiggyAggData.push(obj);
      }

      // Process table data
      for (let i = 0; i <= resp[0].tabledata.length - 1; i++) {
        for (let j = 0; j <= resp[0].tabledata[i].length - 1; j++) {
          let orders = [];
          let obj = resp[0].tabledata[i][j];
          obj.groupL1 = obj.groups[0] ? obj.groups[0] : "";
          obj.groupL2 = obj.groups[1] ? obj.groups[1] : "";
          obj.groupL3 = obj.groups[2] ? obj.groups[2] : "";
          obj.groupL4 = obj.groups[3] ? obj.groups[3] : "";
          obj.date = moment(obj.date).format("DD-MMM");
          obj.duration = shortEnglishHumanizer(obj.duration, {
            round: true,
            largest: 2,
          });
          obj.drivingtime = shortEnglishHumanizer(obj.drivingtime, {
            round: true,
            largest: 2,
          });
          obj.idlingtime = shortEnglishHumanizer(obj.idlingtime, {
            round: true,
            largest: 2,
          });
          obj.waitingtime = shortEnglishHumanizer(obj.waitingtime, {
            round: true,
            largest: 2,
          });
          obj.avgspeed =
            obj.avgspeed % 1 != 0
              ? parseFloat(obj.avgspeed).toFixed(2)
              : obj.avgspeed;
          obj.netearning =
            obj.netearning % 1 != 0
              ? parseFloat(obj.netearning).toFixed(0)
              : obj.netearning;
          obj.cost =
            obj.cost % 1 != 0 ? parseFloat(obj.cost).toFixed(0) : obj.cost;

          obj.orders.map((i) => {
            i.date = moment(i.date).format("DD-MMM");
            i.drivingtime = shortEnglishHumanizer(i.drivingtime, {
              round: true,
              largest: 2,
            });
            i.idlingtime = shortEnglishHumanizer(i.idlingtime, {
              round: true,
              largest: 2,
            });
            i.waitingtime = shortEnglishHumanizer(i.waitingtime, {
              round: true,
              largest: 2,
            });
            i.orderassignmentat = moment(i.orderassignmentat).format(
              "DD-MMM h:mm a"
            );
            i.orderdeliveryat = moment(i.orderdeliveryat).format(
              "DD-MMM h:mm a"
            );
            i.orderduration = shortEnglishHumanizer(i.orderduration, {
              round: true,
              largest: 2,
            });
            i.orderpickupat = moment(i.orderpickupat).format("DD-MMM h:mm a");
            i.speed =
              i.speed % 1 != 0 ? parseFloat(i.speed).toFixed(0) : i.speed;
            i.distance =
              i.distance % 1 != 0
                ? parseFloat(i.distance).toFixed(0)
                : i.distance;
            orders.push(i);
          });
          obj.orders = orders;
          swiggyTableData.push(obj);
        }
      }
    }

    this.finalData = reportData;
    window.swiggyAggData = swiggyAggData;
    window.swiggyTableData = swiggyTableData;
    window.setReportWindowTabBusy(this.schema, false);
  };

  getSwiggyEarningReport = (schema, data, store) => {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, true);

    const auth = window.getAuth();
    let vehicleid = [];
    data.vehicle.map((index) => {
      vehicleid.push(index.data.vehicleid);
    });

    let body = {
      token: auth.token,
      starttime: moment(data.starttime, "DD/MM/YYYY").valueOf(),
      endtime: moment(data.endtime, "DD/MM/YYYY").valueOf(),
      vehicleids: vehicleid,
    };

    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }

    ReportAPIs.getSwiggyReport(body).then((resp) => {
      this.handleSuccess(resp);
    });
  };

  createSchema() {
    return {
      key: "tvs_swiggy_report",
      name: "Swiggy Report",
      toolbar: [
        {
          key: "vehicle",
          type: schemaTypes.MULTI_SELECT,
          storeData: (state) => {
            return {
              data: (() => {
                let newMap = {};
                for (let idx in state.vehicleMap) {
                  if (idx.indexOf("user") === -1) {
                    newMap[idx] = state.vehicleMap[idx];
                  }
                }
                return newMap;
              })(),
              name: "vehicleno",
              id: "vehicleid",
            };
          },
          onItemChange: changeVehicle.bind(this),
          defaultValue: () => {
            return {
              data: (window.selectedVehicles || []).map((i) => {
                return i.id;
              }),
              updatedAt: window.selectedVehiclesUpdatedAt,
            };
          },
        },
        {
          key: "starttime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "Start Date",
          model: Date.now() - 1000 * 60 * 60 * 24,
        },
        {
          key: "endtime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "End Date",
        },
        {
          key: "get_history",
          type: schemaTypes.BUTTON,
          name: "Get Swiggy Report",
          onClick: this.getSwiggyEarningReport,
        },
        {
          key: "download",
          type: schemaTypes.BUTTON,
          iconType: "class",
          icon: "fa fa-download",
          onClick: this.downloadReport,
        },
      ],
      content: [
        {
          key: "reportwidget",
          type: schemaTypes.SWIGGY_WIDGET,
          position: {
            width: 12,
            height: 12,
            left: 0,
            top: 0,
          },
        },
      ],
    };
  }
}

const swiggyReport = new SwiggyReport();
export default swiggyReport.schema;
